const setVars = () => {
  const doc = document.documentElement
  const header = document.querySelector('.header')

  const appHeight = () => {
    doc.style.setProperty('--app-height', `${window.innerHeight}px`)
  }
  const headerHeight = () => {
    doc.style.setProperty('--header-height', `${header.clientHeight}px`)
  }
  appHeight()
  if (header) {
    headerHeight()
  }
}
window.addEventListener('DOMContentLoaded', setVars)
window.addEventListener('resize', setVars)